import React from "react";

import { Table } from "antd";

import PropTypes from "prop-types";

const propTypes = {
    variables: PropTypes.arrayOf(
        PropTypes.exact({
            key: PropTypes.string,
            color: PropTypes.string,
            name: PropTypes.string,
            totales: PropTypes.array,
            totalUnit: PropTypes.string,
        })
    ),
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        })
    ),
    result: PropTypes.string,
};

const defaultProps = {
    variables: [],
    data: [],
};

const DataTable = (props) => {
    const { data, variables, result } = props;

    const unit = result === "Score" ? "%" : "";

    const columns = () => {
        const __columns = [
            {
                title: "Period",
                dataIndex: "name",
                key: "name",
            },
        ];

        for (let p of variables) {
            __columns.push({
                title: p.name,
                dataIndex: p.key,
                key: p.key,
                render: (val, record) => {
                    const total = record[`${p.key}_total`] ?? 0;
                    const totalUnit = p.totalUnit ? ` ${p.totalUnit}` : "";
                    if (total !== 0) {
                        return `${val} ${p.unit} (${total}${totalUnit})`;
                    }
                    if (val) {
                        return `${val} ${p.unit}`;
                    }
                },
            });
        }

        return __columns;
    };

    return (
        <Table dataSource={data || []} columns={columns()} size="small" pagination={false} rowKey={(row) => row.id} />
    );
};

DataTable.propTypes = propTypes;
DataTable.defaultProps = defaultProps;

export default DataTable;
